<template>
  <div>
    <!-- 紧凑模式 -->
    <div v-if="compact && fees.length > 0" class="deposit-compact">
      <span class="compact-label">{{ $t('payFeeDeposit.depositInfo') }}:</span>
      <span class="compact-val" v-for="(fee, idx) in fees" :key="idx">
        {{ fee.feeName }}-{{ fee.receivedAmount }}{{ $t('payFeeDeposit.yuan') || '元' }}
        <el-button type="text" size="mini" @click="openRefundDeposit(fee)">
          {{ $t('payFeeDeposit.refund') }}
        </el-button>
      </span>
      <el-button type="text" size="mini" icon="el-icon-refresh" @click="queryPayFeeDeposit">
        {{ $t('payFeeDeposit.refresh') }}
      </el-button>
    </div>

    <!-- 默认模式 -->
    <el-card v-else-if="!compact && fees.length > 0" class="margin-bottom-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('payFeeDeposit.depositInfo') }}</span>
        <el-button type="primary" size="small" style="float: right;" @click="queryPayFeeDeposit">
          <i class="el-icon-refresh"></i>
          {{ $t('payFeeDeposit.refresh') }}
        </el-button>
      </div>

      <el-table :data="fees" border style="width: 100%" size="mini">
        <el-table-column prop="payerObjName" align="center" :label="$t('payFeeDeposit.payerObj')" />
        <el-table-column prop="feeName" align="center" :label="$t('payFeeDeposit.feeName')" />
        <el-table-column align="center" :label="$t('payFeeDeposit.timeRange')">
          <template slot-scope="scope">
            {{ scope.row.startTime }}~{{ scope.row.endTime }}
          </template>
        </el-table-column>
        <el-table-column prop="receivedAmount" align="center" :label="$t('payFeeDeposit.amount')" />
        <el-table-column prop="createTime" align="center" :label="$t('payFeeDeposit.paymentTime')" />
        <el-table-column align="center" :label="$t('payFeeDeposit.operation')" width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openRefundDeposit(scope.row)">
              {{ $t('payFeeDeposit.refund') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <refund-deposit-fee ref="refundDepositFee" @success="listFeeDeposit"></refund-deposit-fee>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import RefundDepositFee from './refundDepositFee'
import { queryFeeDeposit } from '@/api/fee/payFeeOrderApi'

export default {
  name: 'PayFeeDeposit',
  props: {
    compact: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RefundDepositFee
  },
  data() {
    return {
      dialogVisible: false,
      fees: [],
      payerObjId: '',
      payerObjType: '',
      ownerId: '',
      communityId: ''
    }
  },
  methods: {
    open(params) {
      this.payerObjId = params.payerObjId
      this.payerObjType = params.payerObjType
      this.ownerId = params.ownerId || ''
      this.listFeeDeposit()
    },
    close() {
      this.dialogVisible = false
    },
    async listFeeDeposit() {
      try {
        this.communityId = await getCommunityId()
        const params = {
          page: 1,
          row: 20,
          payerObjId: this.payerObjId,
          ownerId: this.ownerId,
          communityId: this.communityId,
          state: '1400'
        }

        const response = await queryFeeDeposit(params)
        if (response.code === 0) {
          this.fees = response.data || []
        }
      } catch (error) {
        console.error('查询押金信息失败:', error)
      }
    },
    queryPayFeeDeposit() {
      this.listFeeDeposit()
    },
    openRefundDeposit(fee) {
      this.$refs.refundDepositFee.open(fee)
    },
    handleClose() {
      this.fees = []
      this.payerObjId = ''
      this.payerObjType = ''
      this.ownerId = ''
    }
  }
}
</script>

<style scoped>
.compact-label {
  font-weight: bold;
  font-size: 13px;
  color: #303133;
  white-space: nowrap;
}

.compact-val {
  font-size: 13px;
  color: #606266;
}

.deposit-compact {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
</style>